import React from "react";
import { Stack, TextField, useTheme } from "@mui/material";

const DateRangeFilter = ({ startDate, setStartDate, endDate, setEndDate }) => {
  const theme = useTheme();

  // Consistent styles for date pickers across the app
  const dateInputStyles = {
    "& input::-webkit-calendar-picker-indicator": {
      filter: theme.palette.mode === "dark" ? "invert(1)" : "invert(0.4)",
      cursor: "pointer",
    },
  };

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        label="From"
        type="date"
        size="small"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={dateInputStyles}
      />
      <TextField
        label="To"
        type="date"
        size="small"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={dateInputStyles}
      />
    </Stack>
  );
};

export default DateRangeFilter;
